// Distinct, readable-on-white cursor colors (aligned with the mock
// collaborator palette in WorkProductEditor_Text).
const PALETTE = [
    "#a78bfa", "#34d399", "#f472b6", "#60a5fa", "#fbbf24",
    "#f87171", "#2dd4bf", "#c084fc", "#fb923c", "#4ade80"
];

/** Stable per-user presence color derived from the numeric user id. */
export function colorForUser(userid: number): string {
    const index = Math.abs(Math.trunc(userid)) % PALETTE.length;
    return PALETTE[index];
}
